import axios from 'axios';
const api = process.env.VUE_APP_URL;
import checkWindowWidth from '../../../mixins/utils/windowWidthCheck'
import router from '../../../router/index'



export default {
  namespaced: true,
  state() {
    return {
      //тип отображения на странице проектов
      //tile - плитки
      //list - списком
      activeView: 'tile',
      //попап добавления проекта
      showCreateProject: false,
      //чекнутые проекты
      checkedProjects: [],
      //все проекты
      allProjects: [],
      // если проекты пришли в items
      isItemProjects: false,
      //проект с id
      singleProject: '',
      //где находимся,  в проекте или в его подразделении
      isProjectItem: false,

      //добавление юзера в проект popup
      showAddPermission: false,
      //тип добавления
      addPermissionType: 'role',
      //добавление секции в проекте
      showAddSection: false,
      //id добавляемого проекта
      addSectionIdChild: '',

      //управляющие кнопки для поля проектов
      //отображать ли контролы вообще
      showControls: true,
      //масштаб
      scaleIndex: 1,

      //масштабирование включено
      activeZoom: false,
      //показывать ли кнопку масштабирования
      showZoom: true,
      //показывать ли +
      showPlus: false,
      //показывать ли -
      showMinus: false,

      //показывать ли попап удаления
      showDelPopup: false,
      //имя удаляемого
      delItemName: '',
      //id удаляемого
      delItemId: '',

      //navigator
      isOpen: false,

      //drag'n'drop
      currentDroppable: null,
      movedEl: '',
      movedX: '',
      movedY: '',
      movedGroup: '',
      dopElemOnDrag: '',

      draggedEl: '',
      deltaX: '',
      detlaY: '',
      dragX: '',
      dragY: '',
      hiddenEl: false,

      drugConfig: {
        refName: 'projects',
        fullX: 340,
        closedX: 160,
        y: 120,
        dropzone: '.projects-dropzone',
        dropActive: 'projects-drop',
        attr: 'data-project',
      },

      allRoles: [],
      //в хедере единичного проекта полный только в свойствах ноды ТАБЕ (не + и del, а 4 иконки) projectHeader
      isFullHeader: false,
      //состояние редактирования свойста ноды projectSettings
      onSettingsNodeEdit: false,
      //состояние редактирования хедера в свойствах ноды projectHeader
      isHeaderSettingsEditActive: false,
      //инпутc в состоянии редактирования
      onEditingInputs: {},
      //имя при клике в дереве проектов
      dirName: '',

      //чекнутые роли
      checkedRoles: [],

      //удаление роли с проекта
      showDelRoleProject: false,
      delHookRoles: false,

      showDelThingProject: false,
      delHookThing: false,

      activeHeaderTab: 'projectRoles',

      showAddThingInProject: false,
      //массив ролей отображаемых в таблице tableComponent
      displayedRolesInCellProjectRoles: [],
      //массив узлов отображаемых в таблице tableComponent
      displayedSectionsInCellProjectTreeField: [],

      whereINeedGo: ''
    }
  },
  getters: {
    //дерево проектов
    projectsTree(state) {
      if (state.singleProject) {
        let firstItem = state.singleProject;
        let obj = {...firstItem};
        //массив вложенностей
        let arr = state.singleProject.items.slice();

        // нумеруем уровни
        function getProject(arr) {
          let counter = 0;
          getItem(arr);

          function getItem(a) {
            counter++
            for (let item of a) {
              //маркеруем 1 уровень
              item.levelLength = item.items.length;
              item.level = counter;
              getItem(item.items)
            };
          }
        };


        if (state.isProjectItem) {
          //если хотим построить деревяху конкретного уровня
          let level = '';
          function findProject(arr) {
           getItem(arr);

            function getItem(a) {
              for (let item of a) {
                if (state.isProjectItem == item.id) {
                  level = item;
                  break;
                  return;
                } else {
                  getItem(item.items)
                }
              }
            };

          };

         findProject(arr);
         obj.items = level.items;
         obj.id = level.id

         obj.created_at = level.created_at;
         obj.description = level.description;
         obj.devices = level.devices;
         obj.name = level.name;
         obj.project_id = level.project_id;
        } else {
          obj.items = arr;
        }

        getProject(arr);

        obj.items.forEach((item) => {
          item.level = 1
        })

        return obj;
      }
      return ''
    },
    //navigator tree
    navigatorTree(state,getters) {
      let tree = {...state.singleProject};

      //меняем ключ items на children
      tree = JSON.stringify(tree);
      tree = tree.replace(/items/g, 'children');
      tree = JSON.parse(tree);
      //добавляем нужные для плагина параметры
      tree.isMother = true;
      function mapTree(obj) {
        getNode(obj);

        function getNode(o) {
          o.pid = 0;
          o.dragDisabled = true;
          o.addTreeNodeDisabled = true;
          o.addLeafNodeDisabled = true;
          o.editNodeDisabled = true;
          o.delNodeDisabled = true;

          let children = o.children;

          if (children && children.length > 0) {
            o.isLeaf = false;
            for (let item of children) {
              getNode(item)
            }
          } else {
            o.isLeaf = true
          }
        }
      };

      mapTree(tree);
      //костыль для первого элемента
      //ему нужна другая иконка
      //а т.к. дерево собирается из computed свойств
      //удаления не будет, а иконка поменяется
      //...
      //PROFIT

      tree.delNodeDisabled = false;

      return tree;
    },
    //all projects navigator tree
    allProjectsNavigatorTree(state) {
      let allProjectsTree = []
      function makeTree (project) {

        let tree = {...project};
        //меняем ключ items на children
        tree = JSON.stringify(tree);
        tree = tree.replace(/items/g, 'children');
        tree = JSON.parse(tree);
        //добавляем нужные для плагина параметры
        tree.isMother = true;

        function mapTree(obj) {
          getNode(obj);

          function getNode(o) {
            o.pid = 0;
            o.dragDisabled = true;
            o.addTreeNodeDisabled = true;
            o.addLeafNodeDisabled = true;
            o.editNodeDisabled = true;
            o.delNodeDisabled = true;

            let children = o.children;

            if (children && children.length > 0) {
              o.isLeaf = false;
              for (let item of children) {
                getNode(item)
              }
            } else {
              o.isLeaf = true
            }
          }
        };

        mapTree(tree);
        //костыль для первого элемента
        //ему нужна другая иконка
        //а т.к. дерево собирается из computed свойств
        //удаления не будет, а иконка поменяется
        //...
        //PROFIT

        tree.delNodeDisabled = false;
        allProjectsTree.push(tree)
      }

      for (let i = 0; i < state.allProjects.length; i++) {
        makeTree(state.allProjects[i])
      }
      return allProjectsTree;
    },

    projectOwnerRole: state => id => {
      if (state.allRoles) {
        return state.allRoles.find(role => role.id === id)
      }
    },
    adminRole(state) {
      return state.allRoles
    }
  },
  mutations: {
    SET_ADD_PERMISSION_TYPE(state,data) {
      state.addPermissionType = data
    },
    SET_ADD_THING_IN_PROJECT(state,data) {
      state.showAddThingInProject = data
    },
    SET_SHOW_DEL_THING_PROJECT(state,data) {
      state.showDelThingProject = data
    },
    SET_DEL_HOOK_THING(state,data) {
      state.delHookThing = data
    },
    SET_ACTIVE_HEADER_TAB(state,data) {
      state.activeHeaderTab = data
    },
    SET_CHECKED_ROLES(state,data) {
      state.checkedRoles = data
    },
    SET_DEL_HOOK_ROLES(state,data) {
      state.delHookRoles = data;
    },
    SET_SHOW_DEL_ROLE_PROJECT(state,data) {
      state.showDelRoleProject = data
    },
    //navigator
    SET_IS_OPEN_NAVIGATOR(state,data) {
      state.isOpen = data
    },

    //drug'n'drop
    SET_CURRENT_DROPPABLE(state,data) {
      state.currentDroppable = data
    },
    SET_MOVED_EL(state,data) {
      state.movedEl = data
    },
    SET_MOVED_X(state,data) {
      state.movedX = data
    },
    SET_MOVED_Y(state,data) {
      state.movedY = data
    },
    SET_MOVED_GROUP(state,data) {
      state.movedGroup = data
    },
    SET_DOP_ELEM_ON_DRAG(state,data) {
      state.dopElemOnDrag = data
    },
    SET_DRAGGED_EL(state,data) {
      state.draggedEl = data
    },
    SET_DELTA_X(state,data) {
      state.deltaX = data
    },
    SET_DELTA_Y(state,data) {
      state.deltaY = data
    },
    SET_DRAG_X(state,data) {
      state.dragX = data
    },
    SET_DRAG_Y(state,data) {
      state.dragY = data
    },
    SET_HIDDEN_EL(state,data) {
      state.hiddenEl = data
    },

    //устанавливает тип отображения на странице проектов
    SET_ACTIVE_VIEW(state,data) {
      state.activeView = data
    },
    //попап добавления проекта
    SET_SHOW_CREATE_PROJECT(state,data) {
      state.showCreateProject = data
    },
    //чекаем проекты
    SET_CHECKED_PROJECTS(state,data) {
      state.checkedProjects = data
    },
    SET_IS_ITEM_PROJECTS(state,data) {
      state.isItemProjects = data
    },
    //устанавливаем все проекты
    SET_ALL_PROJECTS(state,data) {
      let arr = [];
      let allProjectsArr = [ ...data.projects ];
      let allProjectsItemsArr = [ ...data.items ];
      state.isItemProjects = false;
      let sortProjectArr = (items, id) => {
        items.forEach((item) => {
          item['parentId'] = id;
          item['dopNode'] = false;
          if (item.items && item.items.length > 0) {
            sortProjectArr(item.items, item.id);
          }
        })
      }
      allProjectsArr.forEach((item) => {
        item['isItemProjects'] = false;
        if (item.items && item.items.length > 0) {
          sortProjectArr(item.items, item.id);
        }
      })
      allProjectsItemsArr.forEach((item) => {
        item['isItemProjects'] = true;
        if (item.items && item.items.length > 0) {
          sortProjectArr(item.items, item.id);
        }
      })
      arr = allProjectsArr;
      arr.push(...allProjectsItemsArr)
      state.allProjects = allProjectsArr
    },
    //устанавливаем все роли
    SET_ALL_ROLES(state,data) {
      state.allRoles = data
    },
    //проект с id
    SET_SINGLE_PROJECT(state,data) {
      state.singleProject = '';
      let singleProjectObj = JSON.parse(JSON.stringify(data))
      let sortSingleProjectObj = (items, id) => {
        items.forEach((item) => {
          item['parentId'] = id
          item['dopNode'] = false
          if (item.items && item.items.length > 0) {
            sortSingleProjectObj(item.items, item.id)
          }
        })
      }
      sortSingleProjectObj(singleProjectObj.items, singleProjectObj.id)
      state.singleProject = singleProjectObj
    },
    //где находимся,  в проекте или в его подразделении
    SET_IS_PROJECT_ITEM(state,data) {
      state.isProjectItem = data
    },
    //добавление юзера в проект popup
    SET_SHOW_ADD_PERMISSION(state,data) {
      state.showAddPermission = data
    },
    //добавление секции в проекте
    SET_SHOW_ADD_SECTION(state,data) {
      state.showAddSection = data
    },
    //id добавляемого проекта
    SET_ADD_SECTION_ID_CHILD(state,data) {
      state.addSectionIdChild = data
    },
    //управляющие кнопки для поля проектов
    SET_SHOW_CONTROLS(state,data) {
      state.showControls = data
    },
    //масштабирование включено
    SET_SHOW_ZOOM(state,data) {
      state.showZoom = data
    },
    //показывать ли +
    SET_SHOW_PLUS(state,data) {
      state.showPlus = data
    },
    //показывать ли -
    SET_SHOW_MINUS(state,data) {
      state.showMinus = data
    },
    //масштаб
    SET_SCALE_INDEX(state,data) {
      state.scaleIndex = data
    },
    //масштабирование включено

    SET_ACTIVE_ZOOM(state,data) {
      state.activeZoom = data
    },
    //показывать ли попап удаления
    SET_SHOW_DEL_POPUP(state,data) {
      state.showDelPopup = data
    },
    //имя удаляемого
    SET_DEL_ITEM_NAME(state,data) {
      state.delItemName = data
    },
    //id удаляемого
    SET_DEL_ITEM_ID(state,data) {
      state.delItemId = data
    },
    //установка полного хедера в проекте
    SET_FULL_HEADER(state,data) {
      state.isFullHeader = data
    },
    SET_SETTINGS_NODE_EDITABLE(state,data) {
      state.onSettingsNodeEdit = data
    },
    SET_HEADER_SETTINGS_EDIT_ACTIVE(state,data) {
      state.isHeaderSettingsEditActive = data
    },
    SET_ON_EDITING_INPUTS(state,data) {
      state.onEditingInputs = data
    },
    SET_DIR_NAME(state,data) {
      state.dirName = data
    },
    SET_DISPLAYED_ROLES_IN_CELL_PROJECT_ROLES(state, data) {
      state.displayedRolesInCellProjectRoles = data
    },
    SET_DISPLAYED_SECTIONS_IN_CELL_PROJECT_TREE_FIELD(state, data) {
      state.displayedSectionsInCellProjectTreeField = data
    },
    SET_WHERE_I_NEED_GO (state, data) {
      state.whereINeedGo = data
    }
  },
  actions: {
    //получение проектов
    async getProjects({commit, dispatch, rootState}) {
      await axios({
        method: 'get',
        url: `${api}project/get-all`,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        commit('SET_ALL_PROJECTS', res.data)
        commit('SET_ALL_ROLES', res.data.roles);
        commit('roles/SET_ALL_ROLES', res.data.roles, {root: true});

        // console.log('ниже res.data.projects из getProjects Action (project/get-all)')
        // console.log(res.data)

        commit('things/SET_OWNED_THINGS', res.data, { root: true })
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    },
    //TODO убрать эндпоинт и искать в get-all
    //получение конкретного проекта по id
    async getProject({commit, dispatch, rootState}, id) {
      await axios({
        method: 'get',
        url: `${api}project/get?id=${id}`,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        commit('SET_SINGLE_PROJECT', res.data.project_data)
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    },
    //получение конкретной ноды по id
    async getProjectItem({commit, dispatch, rootState}, id) {
      await axios({
        method: 'get',
        url: `${api}project-item/get?id=${id}`,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        commit('SET_SINGLE_PROJECT', res.data.item_data)
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        }
      })
    },
    //создание проекта
    async createProject({dispatch, rootState}, data) {
      let responceData;
      await axios({
        method: 'post',
        url: `${api}project/create`,
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': rootState.auth.token
        }
      }).then(async res => {
        responceData = res;
        return res;
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
        //throw new Error('error')
      });
      return responceData
    },
    //создание project_item/подразделения проекта
    async createProjectItem({dispatch, rootState}, data) {
      let responceData;
      await axios({
        method: 'post',
        url: `${api}project-item/create`,
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': rootState.auth.token
        }
      }).then(async res => {
        responceData = res;
        return res;
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      });
      return responceData
    },
    //апдейт проекта
    async updateProject({rootState, dispatch}, data) {
      await axios({
        method: 'post',
        url: `${api}project/update`,
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': rootState.auth.token
        }
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
        throw new Error('error')
      })
    },
    async updateProjectItem({rootState,dispatch}, data) {
      await axios({
        method: 'post',
        url: `${api}project-item/update`,
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': rootState.auth.token
        }
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
        throw new Error('error')
      })
    },

    async moveItem({rootState, dispatch}, data) {
      await axios({
        method: 'post',
        url: `${api}project-item/move`,
        data,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(async res => {
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
        throw new Error('error')
      })
    },
    //удаление проекта
    async delProject({rootState, dispatch}, id) {
      await axios({
        method: 'post',
        url: `${api}project/delete`,
        data: {
          id
        },
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(res => {
        dispatch('getProjects')
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    },
    //удаление project_item
    async delProjectItem({rootState, dispatch}, id) {
      await axios({
        method: 'post',
        url: `${api}project-item/delete`,
        data: {
          id
        },
        headers: {
          'Authorization': rootState.auth.token
        }
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    },

    async delProjectImage({rootState, dispatch}, id) {
      await axios({
        method: 'post',
        url: `${api}project/clear-image`,
        data: {
          id
        },
        headers: {
          'Authorization': rootState.auth.token
        }
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    },
    async delProjectItemImage({rootState,dispatch}, id) {
      await axios({
        method: 'post',
        url: `${api}project-item/clear-image`,
        data: {
          id
        },
        headers: {
          'Authorization': rootState.auth.token
        }
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    },

    async setPermissions({rootState, dispatch}, obj) {
      await axios({
        method: 'post',
        url: `${api}permission/set`,
        data: obj.data,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then((res) => {
        dispatch('getProjects')
      })
      .catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    },
    async removePermission({rootState,dispatch}, obj) {
      await axios({
        method: 'post',
        url: `${api}permission/delete`,
        data: obj.data,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(() => {
        dispatch('getProject', obj.id)
      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    },

    async addDeviceInProject({rootState, dispatch}, obj){
      await axios({
        method: 'post',
        url: `${api}devices/move`,
        data: obj.data,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(() => {

      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    },
    async delDeviceFromProject({rootState, dispatch}, obj) {
      await axios({
        method: 'post',
        url: `${api}devices/remove`,
        data: obj.data,
        headers: {
          'Authorization': rootState.auth.token
        }
      }).then(() => {

      }).catch(e => {
        let res = e.response.data;

        if (res.message.includes('access')) {
          dispatch('auth/logout', '', {root: true})
        };
      })
    }
  }
}

// /project/get-all - получение всех проектов GET
// /project/get?id=1 - получение одного проекта по id GET
// /project/create - создание проекта (обязательные:[name], остальные:[description, image]) POST
// /project/update- создание проекта (обязательные:[name,id], остальные:[description, image]) POST
// /project/delete - удаление по id DELETE
// /project/restore - восстановление по id POST

// /project-item/get-all - получение всех элементов проекта(вложенные выводятся) GET
// /project-item/get - получение элемента проекта по id(вложенности выводятся) GET
// /project-item/create -создание элемента проекта(обязательные:[name,project_id], остальные:[description,parent_item_id,image]) POST
// /project-item/update-создание элемента проекта(обязательные:[name,project_id], остальные:[description,parent_item_id,image]) POST
// /project-item/delete - удаление по id DELETE
// /project-item/restore - восстановление по id POST
// project-item/move , id - тот который перемещать, parent_item_id - куда перемещать(-1 переместить в проект), only_this переместить только один



